<template>
  <div>
    <page-main
      ref="main"
      :tableData="tableData"
      :tablePage="page"
      :loading="loading"
      :disabled="disabled"
      @reload="reload"
      @openEditFormDialog="openEditFormDialog"
      @batchDel="submitDel"
    >
      <page-header
        ref="header"
        slot="header"
        :disabled="disabled"
        @query="getData"
        @reset="resetPage"
        @openEditFormDialog="openEditFormDialog"
        @batchDel="batchDel"
        @onClickPrint="onClickPrint"
      />
    </page-main>
    <el-dialog
      v-if="editFormDialogOptions.visible"
      show-close
      visible
      width="1000px"
      top="3vh"
      :title="editFormDialogOptions.title"
      :close-on-click-modal="false"
      :before-close="() => $refs.editForm.cancel()"
    >
      <batch-table-edit-form
        ref="editForm"
        :code="editFormDialogOptions.code"
        :changeOrderCode="editFormDialogOptions.changeOrderCode"
        :isAdd="editFormDialogOptions.isAdd"
        :disabled="editFormDialogOptions.disabled"
        :params="editFormDialogOptions.params"
        :isCopy="editFormDialogOptions.isCopy"
        @reload="reload"
        @close="closeEditFormDialog"
      />
      <span slot="footer">
        <el-button size="small" @click="$refs.editForm.cancel()">{{
          $l('INDEX.btn_cancel') || '取消'
        }}</el-button>
        <el-button
          type="primary"
          size="small"
          v-if="!editFormDialogOptions.disabled"
          @click="$refs.editForm.save()"
          >{{ $l('INDEX.btn_save') || '保存' }}</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      v-if="exportVisible"
      show-close
      :visible.sync="exportVisible"
      width="500px"
      :title="$l('INDEX.btn_export_batch') || '导出批次信息'"
      :close-on-click-modal="false"
      :before-close="() => close()"
    >
      <div class="print_btn_group">
        <el-button plain @click="exportExcel('one')">
          {{ $l('INDEX.btn_Template_One') || '模版一' }}
        </el-button>
        <el-button plain @click="exportExcel('two')">
          {{ $l('INDEX.btn_Template_Two') || '模版二' }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PageMain from './main.vue'
import PageHeader from './header.vue'
import BaseTable from '@/mixins/base-table'
import BatchTableEditForm from '../batch-table-edit-form/index.vue'
import EditLoading from '@/mixins/edit-loading'
export default {
  props: {
    changeOrderCode: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    PageMain,
    PageHeader,
    BatchTableEditForm,
  },
  mixins: [BaseTable, EditLoading],
  data() {
    return {
      usePage: true,
      exportVisible: false,
      editFormDialogOptions: {
        visible: false,
        code: '',
      },
    }
  },
  mounted() {},
  methods: {
    getData(form) {
      this.page.pageSize = 1000 //设置查询最大条数为1000
      this.loading = true
      this.$api
        .changeOrderBatchListApi({
          changeOrderCode: this.changeOrderCode,
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditFormDialog({ type, params = {} }) {
      const types = {
        edit:
          this.$l('INDEX.dialog_title_order_batch_edit') ||
          '编辑订单交货批次信息',
        add:
          this.$l('INDEX.dialog_title_order_batch_add') ||
          '添加订单交货批次信息',
        detail:
          this.$l('INDEX.dialog_title_order_batch_detail') ||
          '订单交货批次详情',
        copy:
          this.$l('INDEX.dialog_title_order_batch_copy') ||
          '复制订单交货批次信息',
      }
      this.editFormDialogOptions = {
        visible: true,
        type,
        title: types[type],
        code: params.changeOrderBatchCode,
        disabled: type === 'detail',
        isAdd: type === 'add',
        changeOrderCode: this.changeOrderCode,
        isCopy: type === 'copy',
      }
    },
    closeEditFormDialog() {
      this.editFormDialogOptions.visible = false
    },
    //批量删除的操作
    batchDel() {
      const listCode = this.$refs.main.getCheckboxRecords()
      if (listCode) this.submitDel(listCode)
    },
    submitDel(listCode) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => {
          this.$api
            .changeOrderBatchDelApi({
              listCode,
              changeOrderCode: this.changeOrderCode,
            })
            .then(() => {
              this.$message({
                showClose: true,
                message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
                type: 'success',
              })
              this.$refs.header.query()
            })
        })
        .catch(() => {})
    },
    onClickPrint() {
      this.exportVisible = true
    },
    exportExcel(type) {
      // 调用批次导出接口，确认是否有对应数据
      let parms = {
        changeOrderCode: this.changeOrderCode,
      }
      this.loadingOpen()
      this.$api
        .changeOrderBatchGoodsCheckDataApi(parms)
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status === 200) {
            // 通过数据检查，增加下载任务
            const taskName = `factory-order-batch`
            this.addExportTask(taskName, type)
          }
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    addExportTask(taskName, type) {
      const context = {
        orderCode: this.changeOrderCode,
        type: type,
        mode: 'B',
      }
      this.loadingOpen()
      this.$api
        .SYS_EXPORT_TASK(taskName, context)
        .then((res) => {
          this.loadingClose()
          const { status } = res || {}
          if (200 === status) {
            this.$message({
              message:
                this.$l('INDEX.added_to_the_download_center') ||
                '导出任务已经添加到下载中心，请稍后从下载中心下载文件',
              type: 'success',
            })
            this.close()
            return
          } else {
            this.$message.error(
              this.$l('INDEX.Description_Failed_to_add_export_task') ||
                '导出任务添加失败'
            )
          }
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(
            this.$l('INDEX.Description_Failed_to_add_export_task') ||
              '导出任务添加失败'
          )
        })
      this.close()
    },
    close() {
      this.exportVisible = false
    },
  },
}
</script>
<style scoped>
.print_btn_group {
  height: 110px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
</style>
